import { usePlanStockTerm as useStockTerm } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-term/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanStockTerm = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { stockTypeTarget, stockTypeTerm, maxStockNum } = viewModel;

	return useStockTerm({
		stockTypeTerm,
		stockTypeTarget,
		maxStockNum,
		onSetViewModel,
	});
};
